<div id="caixa-tem">
  <div class="banner-area">
    <div class="container">
      <div class="text-area">
        <h1>
          Agora tem azulzinha no
          <span style="color: #a3ca37">App CAIXA Tem!</span>
        </h1>
        <p class="mt-4">
          Venda sem a maquininha e receba direto na sua conta digital MEI
        </p>
        <div class="mt-4">
          <img
            class="img-fluid"
            [lazyLoad]="'/assets/img/logos/caixa-tem-v01.svg'"
            alt=""
          />
        </div>
        <div class="mt-4">
          <a
            class="btn btn-primary px-5 lp-azulzinha-caixa-tem-saiba-mais"
            href="/azulzinha-caixa-tem#dobra"
            >Saiba como
          </a>
        </div>
      </div>
    </div>
  </div>
  <div class="container">
    <div id="dobra" class="row mt-5-md">
      <div class="mt-5 col-lg-5 col-12 mb-4">
        <h2 class="mb-4">Tudo 100% digital para você vender mais</h2>
        <p>
          Você, que tem o App CAIXA Tem, pode transformar seu celular em
          maquininha e começar a vender com a azulzinha da CAIXA. Tudo de forma
          simples e prática com recebimento de suas vendas direto na conta
          digital MEI, disponível também pelo aplicativo.
        </p>
        <p>Assista ao vídeo e saiba como ter sua azulzinha!</p>
      </div>
      <div class="col-lg-7 col-12">
        <video
          controlsList="nodownload"
          controls
          type="video/mp4"
          poster="assets/img/video-azulzinha-caixatem.png"
          width="100%"
          height="100%"
        >
          <source
            src="{{
              env.origin
            }}/midias/azulzinha-CAIXATem-V3-Reduzido-primeiro-acesso.mp4"
            type="video/mp4"
          />
        </video>
      </div>
    </div>
  </div>
  <section class="container">
    <header class="text-center mb-5">
      <h2>
        Com a azulzinha no seu celular você pode muito mais! <br />
        Conheça as funcionalidades disponíveis:
      </h2>
    </header>
    <swiper
      class="container-card-swiper"
      [slidesPerView]="3"
      [breakpoints]="myConfig"
      [spaceBetween]="0"
      [navigation]="true"
    >
      <ng-template *ngFor="let item of cards" swiperSlide>
        <app-card-component [Items]="item"></app-card-component>
      </ng-template>
    </swiper>
    <footer class="text-center mt-5">
      <a class="btn btn-primary" href="/azulzinha-caixa-tem#next-dobra"
        >Veja como é fácil ter sua azulzinha</a
      >
    </footer>
  </section>
  <section class="content-bg-gray">
    <div class="container container-bandeiras row flex">
      <div class="header-bandeiras col-md-5">
        <h2>
          A azulzinha aceita as bandeiras, vouchers e carteiras digitais
          favoritas do seu cliente<sup style="font-size: 12px">*</sup>
        </h2>
        <p>
          Venda de maneira conveniente, sem a maquininha, e receba o dinheiro
          diretamente em sua conta digital MEI
        </p>
      </div>
      <div class="content-bandeiras col-md-7">
        <div class="bandeira">
          <img [lazyLoad]="'assets/img/bandeiras/logo12.png'" alt="" />
        </div>
        <div class="bandeira">
          <img [lazyLoad]="'assets/img/bandeiras/logo19.png'" alt="" />
        </div>
        <div class="bandeira">
          <img [lazyLoad]="'assets/img/bandeiras/logo31.png'" alt="" />
        </div>
        <div class="bandeira">
          <img [lazyLoad]="'assets/img/bandeiras/logo2.png'" alt="" />
        </div>
        <div class="bandeira">
          <img [lazyLoad]="'assets/img/bandeiras/logo18.png'" alt="" />
        </div>
        <div class="bandeira border-none">
          <img [lazyLoad]="'assets/img/bandeiras/caixa-tem-logo.png'" alt="" />
        </div>
        <div class="bandeira border-none">
          <img [lazyLoad]="'assets/img/bandeiras/picpay.png'" alt="" />
        </div>
        <div class="bandeira border-none">
          <img [lazyLoad]="'assets/img/bandeiras/bee.png'" alt="" />
        </div>
        <div class="bandeira border-none">
          <img [lazyLoad]="'assets/img/bandeiras/uber.png'" alt="" />
        </div>
        <div class="bandeira border-none">
          <img [lazyLoad]="'assets/img/bandeiras/palmeiras.png'" alt="" />
        </div>
        <div class="bandeira border-none">
          <img [lazyLoad]="'assets/img/bandeiras/pernambucanas.png'" alt="" />
        </div>
        <div class="bandeira border-none">
          <img [lazyLoad]="'assets/img/bandeiras/dotz.png'" alt="" />
        </div>
        <div class="bandeira border-none">
          <img [lazyLoad]="'assets/img/bandeiras/vallo.png'" alt="" />
        </div>

        <div class="bandeira border-none">
          <img [lazyLoad]="'assets/img/bandeiras/br.png'" alt="" />
        </div>
        <div class="bandeira border-none">
          <img [lazyLoad]="'assets/img/bandeiras/cs.png'" alt="" />
        </div>
        <div class="bandeira border-none">
          <img [lazyLoad]="'assets/img/bandeiras/abastece.png'" alt="" />
        </div>
        <div class="bandeira border-none">
          <img [lazyLoad]="'assets/img/bandeiras/livelo.png'" alt="" />
        </div>
        <div class="bandeira border-none">
          <img
            [lazyLoad]="'assets/img/bandeiras/bradesco-cartoes-logo.png'"
            alt=""
          />
        </div>
        <div class="bandeira border-none">
          <img [lazyLoad]="'assets/img/bandeiras/cashin.png'" alt="" />
        </div>
        <div class="bandeira border-none">
          <img [lazyLoad]="'assets/img/bandeiras/ifood.png'" alt="" />
        </div>
      </div>
      <div class="footer mt-5 col-md-9">
        <span id="next-dobra"
          >*Bandeira American Express disponível via Link de Pagamento, VR
          Benefícios por meio de QR Code. Para azulzinha aproxima, utilizando a
          bandeira Visa, o limite das transações é de R$200, mas pode variar
          conforme banco emissor.
          <!-- <a
            style="text-decoration: underline !important"
            routerLink="/azulzinha-aproxima"
            >Saiba mais</a
          > -->
        </span>
      </div>
    </div>
    <div></div>
  </section>

  <section>
    <h2 class="text-center pb-5 mb-0">
      Passo a passo para habilitar a azulzinha no seu App CAIXA Tem
    </h2>

    <div class="tab-buttons">
      <button
        (click)="changeCaruselIndex(0)"
        [ngClass]="{ active: carrosselIndex == 0 }"
      >
        Ativação
      </button>
      <button
        (click)="changeCaruselIndex(1)"
        [ngClass]="{ active: carrosselIndex == 1 }"
      >
        Identificação
      </button>
    </div>

    <div class="section-swiper pt-0">
      <div class="container">
        <swiper
          #mySwiper
          class="container-card-swiper"
          [slidesPerView]="3"
          [breakpoints]="myConfig"
          [spaceBetween]="0"
          [navigation]="true"
        >
          <ng-template
            *ngFor="
              let celular of carrosselIndex == 0 ? celHabilita : celIndetifica;
              let key = index
            "
            swiperSlide
          >
            <div class="text-center">
              <div class="circle-number">
                {{ key + 1 }}
              </div>
              <div class="card-cel pt-4">
                <img
                  class="img-fluid"
                  style="width: 300px"
                  [src]="'assets/img/' + celular.img"
                  alt=""
                />
                <p
                  style="padding-inline: 4rem; text-align: center"
                  [innerHTML]="celular.text"
                ></p>
              </div>
            </div>
          </ng-template>
        </swiper>
      </div>
    </div>
  </section>

  <section>
    <div class="container">
      <div class="text-center mt-5">
        <h4>Ainda não tem o App CAIXA Tem? Baixe o seu agora!</h4>
        <div class="col-md-4 m-auto">
          Não se esqueça: para ter a azulzinha, você precisa ter a Conta Digital
          MEI
        </div>
      </div>
      <div
        style="display: flex; align-items: center; justify-content: center"
        class="cta mt-5 text-center"
      >
        <a
          class="lp-azulzinha-caixa-tem-app-store"
          target="_blank"
          href="https://apps.apple.com/br/app/caixa-tem/id1485424267"
          ><img [lazyLoad]="'assets/img/app-store-btn.png'" alt=""
        /></a>
        <a
          class="lp-azulzinha-caixa-tem-google-play"
          target="_blank"
          href="https://play.google.com/store/apps/details?id=br.gov.caixa.tem&hl=pt_BR"
          ><img [lazyLoad]="'assets/img/google-play.png'" alt=""
        /></a>
      </div>
    </div>
  </section>
  <section id="videos">
    <app-playlist-videos defaultCategory="CAIXA Tem"> </app-playlist-videos>
  </section>
  <section id="videos" class="faq">
    <h2 class="text-center font-sm">
      Tire suas dúvidas sobre a azulzinha no App CAIXA Tem
    </h2>
    <div #elementoRef>
      <app-faq-componente [faq]="faqArray"></app-faq-componente>
    </div>
  </section>
</div>
